import "./BrokerRiskRowComponent.scss";
import {RiskRowEntityType} from "../../../models/RiskRowEntityType";
import {BrokerViewRow} from "../../../models/view-model/RiskDashboardViewModel";
import {RiskDashboardViewStore} from "../../../store/RiskDashboardViewStore";

export const BrokerRiskRow = "brokerRiskRow";

export function brokerRiskRow() {
    return {
        templateUrl: "app/risk/dashboard/components/grid/broker/BrokerRiskRowComponent.html",
        bindings: {
            broker: "<",
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: BrokerRiskRowComponentController
    };
}

export class BrokerRiskRowComponentController {
    public readonly broker: BrokerViewRow;
    public readonly viewStore: RiskDashboardViewStore;

    public toggleCollapse() {
        this.viewStore.toggleCollapse(RiskRowEntityType.BROKER, this.broker.entity.id);
    }
}
